export default {
  changeApplicationNo: 'change application No',
  nameOfChangeApplication: 'name of change application',
  changeApplicationCriteria: 'change application criteria',
  version: 'version',
  changeContent: 'change content',
  changeApplicant: 'change applicant',
  changeApplicationTime: 'change application time',
  status: 'status',
  createAChangeApplication: 'create a change application',
  viewTheChangeApplication: 'view the change application',
  editTheChangeApplication: 'edit the change application',
  pleaseEnterTheChangeRequestNumber: 'please enter the change request number',
  onlyLettersNumbersUnderscores:
    'only letters / numbers / underscores can be entered and pure numbers cannot be entered',
  pleaseEnterTheName: 'please enter the name',
  pleaseSelectChangeStandard: 'please select the change standard',
  ConfirmDeleteTheChangeApplication: 'whether delete the change application?',
}
